(() => {
  const root = document.documentElement;
  const token = () => window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  function updateSpecification(scope) {
    scope.querySelectorAll('[data-dsg-detailed-size]').forEach(group => {
      const selected = group.querySelector('input:checked');
      const detail = group.querySelector('[data-dsg-selected-spec]');
      if (selected && detail) detail.textContent = selected.value;
    });
  }
  document.addEventListener('change', event => {
    const group = event.target.closest('[data-dsg-detailed-size]');
    if (group) updateSpecification(group.parentElement);
  });
  function setupInquiry(scope) {
    scope.querySelectorAll('[data-dsg-inquiry]').forEach(form => {
      if (form.dataset.dsgReady) return;
      form.dataset.dsgReady = 'true';
      const select = form.querySelector('[data-dsg-request-type]');
      const fields = form.querySelector('[data-dsg-bulk-fields]');
      if (select && location.hash === '#dsg-bulk-inquiry') select.value = 'Bulk order';
      const sync = () => {
        if (!fields || !select) return;
        fields.hidden = select.value !== 'Bulk order';
        fields.querySelectorAll('input,select,textarea').forEach(input => {
          input.disabled = fields.hidden;
          input.required = !fields.hidden && input.hasAttribute('data-dsg-bulk-required');
        });
      };
      select?.addEventListener('change', sync);
      sync();
      form.addEventListener('submit', () => {
        if (!form.checkValidity()) return;
        try { sessionStorage.setItem('dsg-inquiry-attempt', JSON.stringify({id:token(),type:select?.value === 'Bulk order' ? 'bulk' : 'customer_service'})); } catch (_) {}
      });
      const success = form.querySelector('[data-dsg-inquiry-success]');
      if (success) {
        // Capture the attempt attached to this native success render. A later
        // submit on the old success page must wait for its own server response.
        let attempt;
        try { attempt = JSON.parse(sessionStorage.getItem('dsg-inquiry-attempt') || 'null'); } catch (_) {}
        if (!attempt || typeof attempt.id !== 'string' || !/^[A-Za-z0-9._:-]{1,128}$/.test(attempt.id) || !['bulk','customer_service'].includes(attempt.type)) return;
        const completedKey = `dsg-inquiry-sent-${attempt.id}`;
        try { if (sessionStorage.getItem(completedKey)) return; } catch (_) { return; }
        const publications = setupInquiry.publications || (setupInquiry.publications = new Map());
        let state = publications.get(attempt.id);
        if (state && state.type !== attempt.type) return;
        if (!state) {
          const keys = {shopify:`dsg-inquiry-shopify-sent-${attempt.id}`,ga4:`dsg-inquiry-ga4-sent-${attempt.id}`};
          let sent;
          try { sent = {shopify:!!sessionStorage.getItem(keys.shopify),ga4:!!sessionStorage.getItem(keys.ga4)}; } catch (_) { return; }
          state = {type:attempt.type,forms:new Set(),sent,pending:{shopify:false,ga4:false},timer:0,retries:0,done:false};
          publications.set(attempt.id,state);
          const delays = [250,750,1500,3000,6000,10000];
          const consent = () => {
            try {
              const privacy = window.Shopify?.customerPrivacy;
              if (typeof privacy?.analyticsProcessingAllowed !== 'function') return null;
              return privacy.analyticsProcessingAllowed() === true;
            } catch (_) { return null; }
          };
          const current = () => {
            if (![...state.forms].some(f=>f.isConnected && f.querySelector('[data-dsg-inquiry-success]'))) return false;
            try {
              const active = JSON.parse(sessionStorage.getItem('dsg-inquiry-attempt') || 'null');
              return active?.id === attempt.id && active.type === attempt.type;
            } catch (_) { return false; }
          };
          const stop = () => { if (state.timer) clearTimeout(state.timer); state.timer = 0; };
          const mark = destination => {
            // Preserve the successful destination in memory even if storage
            // becomes unavailable; never repeat it during this page lifetime.
            state.sent[destination] = true;
            try { sessionStorage.setItem(keys[destination], '1'); } catch (_) {}
          };
          const finish = () => {
            if (!state.sent.shopify || !state.sent.ga4) return;
            state.done = true;
            stop();
            try {
              sessionStorage.setItem(completedKey, '1');
              const active = JSON.parse(sessionStorage.getItem('dsg-inquiry-attempt') || 'null');
              if (active?.id === attempt.id) sessionStorage.removeItem('dsg-inquiry-attempt');
            } catch (_) {}
            publications.delete(attempt.id);
          };
          const retry = () => {
            if (state.done || state.timer || !current() || consent() === false || state.retries >= delays.length) return;
            state.timer = setTimeout(()=>{ state.timer = 0; state.run(false); },delays[state.retries++]);
          };
          state.run = (restart = false) => {
            if (state.done) { stop(); return; }
            if (restart) { stop(); state.retries = 0; }
            if (!current()) { stop(); return; }
            const allowed = consent();
            if (allowed === false) { stop(); return; }
            if (allowed !== true) { retry(); return; }
            if (!state.sent.shopify) {
              if (state.pending.shopify) return;
              if (typeof window.Shopify?.analytics?.publish !== 'function') { retry(); return; }
              state.pending.shopify = true;
              let publication;
              try {
                publication = window.Shopify.analytics.publish('disangni_inquiry_submitted', {submission_id:attempt.id,form_type:attempt.type});
              } catch (_) { state.pending.shopify = false; retry(); return; }
              Promise.resolve(publication).then(accepted=>{
                state.pending.shopify = false;
                if (accepted === false) { retry(); return; }
                mark('shopify');
                // Consent may have changed while Shopify was publishing.
                // GA4 is attempted only after a fresh official consent check.
                state.run(false);
              }).catch(()=>{ state.pending.shopify = false; retry(); });
              return;
            }
            if (!state.sent.ga4) {
              if (state.pending.ga4) return;
              if (typeof window.gtag !== 'function') { retry(); return; }
              state.pending.ga4 = true;
              let publication;
              try {
                // Allowlisted fields only: no contact details or message body.
                publication = window.gtag('event','generate_lead',{send_to:'G-FQEQG31F9W',form_type:attempt.type,submission_id:attempt.id});
              } catch (_) { state.pending.ga4 = false; retry(); return; }
              Promise.resolve(publication).then(accepted=>{
                state.pending.ga4 = false;
                if (accepted === false) { retry(); return; }
                mark('ga4');
                finish();
              }).catch(()=>{ state.pending.ga4 = false; retry(); });
              return;
            }
            finish();
          };
        }
        state.forms.add(form);
        state.run(false);
        document.addEventListener('visitorConsentCollected', ()=>state.run(true));
        document.addEventListener('disangni:privacy-ready', ()=>state.run(true));
      }
    });
  }
  function bulkInquiry(event) {
    const anchor = event.target.closest('a');
    if (!anchor) return;
    const href = anchor.getAttribute('href') || '';
    if (!/mailto:.*subject=.*bulk|#dsg-bulk-inquiry/i.test(href)) return;
    const form = document.querySelector('[data-dsg-inquiry]');
    if (!form) return;
    event.preventDefault();
    const select = form.querySelector('[data-dsg-request-type]');
    if (select) { select.value = 'Bulk order'; select.dispatchEvent(new Event('change',{bubbles:true})); }
    form.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
    form.querySelector('input[type="email"]')?.focus({preventScroll:true});
  }
  document.addEventListener('click', bulkInquiry);
  let chatFrame;
  const observedChatRoots = new WeakSet();
  const chatObserver = new MutationObserver(scheduleChat);
  function scheduleChat() {
    if (chatFrame) return;
    chatFrame = requestAnimationFrame(() => {
      chatFrame = 0;
      const chatRoot = document.querySelector('shopify-chat')?.shadowRoot;
      const runtimeRoot = chatRoot?.querySelector('shopify-agent-runtime')?.shadowRoot;
      for (const shadowRoot of [chatRoot, runtimeRoot]) {
        if (shadowRoot && !observedChatRoots.has(shadowRoot)) {
          observedChatRoots.add(shadowRoot);
          chatObserver.observe(shadowRoot, {childList:true,subtree:true});
        }
      }
      const activators = [
        ...chatRoot?.querySelectorAll('[part="activator"]') || [],
        ...runtimeRoot?.querySelectorAll('[part="activator"]') || []
      ];
      const activator = activators.find(button => {
        const r = button.getBoundingClientRect();
        return r.width && r.height;
      }) || activators[0];
      // Moving the public activator part leaves its transparent nudge wrapper in place.
      // A zero-size direct placeholder can coexist with the visible nested activator.
      for (const button of activators) {
        const nudge = button.closest('.activator-nudge');
        if (nudge) nudge.style.pointerEvents = 'none';
      }
      const modalVisible = [...document.querySelectorAll('dialog[open],[role="alertdialog"],[role="dialog"][aria-modal="true"]')].some(e=>{const r=e.getBoundingClientRect();return r.width&&r.height;});
      if (!matchMedia('(max-width: 749px)').matches) { root.classList.remove('dsg-chat-lift');root.classList.toggle('dsg-chat-hide',modalVisible);return; }
      const buttons = [...document.querySelectorAll('[data-add-to-cart],button[name="checkout"],.cart__checkout,[data-dsg-inquiry] button[type="submit"]')];
      const visible = buttons.filter(button => { const r=button.getBoundingClientRect(); return r.width && r.height && r.top<innerHeight && r.bottom>0; });
      root.classList.toggle('dsg-chat-lift', visible.length > 0);
      const chat = activator?.getBoundingClientRect();
      const targets = [...visible,...document.querySelectorAll('textarea:focus,input:focus,.variant__button-label')];
      const overlap = chat && targets.some(target => { const r=target.getBoundingClientRect(); return r.width && r.height && r.left<chat.right && r.right>chat.left && r.top<chat.bottom && r.bottom>chat.top; });
      root.classList.toggle('dsg-chat-hide', Boolean(overlap)||modalVisible);
    });
  }
  window.addEventListener('scroll',scheduleChat,{passive:true});
  window.addEventListener('resize',scheduleChat,{passive:true});
  document.addEventListener('focusin',scheduleChat);
  document.addEventListener('focusout',scheduleChat);
  document.addEventListener('shopify:section:load',event=>{updateSpecification(event.target);setupInquiry(event.target);scheduleChat();});
  document.addEventListener('DOMContentLoaded',()=>{updateSpecification(document);setupInquiry(document);scheduleChat();});
  if (document.readyState !== 'loading') {updateSpecification(document);setupInquiry(document);scheduleChat();}
  chatObserver.observe(document.body,{childList:true,subtree:true});
})();
